import React from 'react'


const UniversalJsonTable = (props) => {

   

    return (
        <div>

            <table className='tm-custom-table'>
                <thead>

                    <tr>
                        <td rowSpan={2}>Denumirea Elementului</td>
                        <td rowSpan={2}>Nr. Rd.</td>
                        <td colSpan={2}>Sold La:</td>



                    </tr>

                    <tr>
                        <td>01.02.{props.bilant[0].an}</td>
                        <td>31.12.{props.bilant[0].an}</td>
                    </tr>
                </thead>
                <tbody>
                    {props.bilant && props.bilant[0].rows.map((c, idx) => {
                        return (
                            <tr key={idx}>
                                {/* <td>{c.idx}</td> */}
                                <td >


                                {c.descriere}

                                </td>

                                <td >


                                {c.nr_rd}

                                </td>
                                <td >

                                    <input
                                        style={{ fontWeight: 600 }}
                                        disabled={props.readOnlyCapitole}
                                        type={'text'}
                                        value={c.sold_initial}
                                        className='tm-table-input'
                                        name='sold_initial'
                                        onChange={(ev) => { props.changeValoare(ev, idx) }}
                                        onBlur={() =>{props.onBlurValoare(idx, 'sold_initial')}}
                                        />


                                </td>
                                <td >

                                    <input
                                        style={{ fontWeight: 600 }}
                                        disabled={props.readOnlyCapitole}
                                        type={'text'}
                                        value={c.sold_final}
                                        className='tm-table-input'
                                        name='sold_final'
                                        onChange={(ev) => { props.changeValoare(ev, idx) }}
                                        onBlur={()=>{props.onBlurValoare(idx, 'sold_final')}}
                                        />


                                </td>

                            </tr>
                        )


                    })}
                </tbody>
            </table>
        </div >


    )

}


export default UniversalJsonTable;